import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveFeedback, setLoader } from "../../actions/Header";
import { validateEmail } from "../Utils/Util";

const FeedbackForm = ({ openCloseModal }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [toc, setToc] = useState("");
  const [msg, setMsg] = useState("");
  const [attachmentFile, setAttachmentFile] = useState([]);
  const [validationErr, setValidationErr] = useState({});
  const store = useSelector((state) => state);
  const { profileReducer: profile, usersReducers } = store;
  const dispatch = useDispatch();
  useEffect(() => {
    setName(profile.fullname);
    setEmail(profile.email);
    setToc(profile.params.TestAppParam || profile.params.TOC);
  }, []);

  const onSaveHandler = () => {
    let validationErr = {};
    let isValidEmail = validateEmail(email);

    // if (name === "") {
    //   validationErr.NameErr = "Name cannot be left blank.";
    // } else if (email === "") {
    //   validationErr.EmailErr = "Email cannot be left blank.";
    // } else if (!isValidEmail) {
    //   validationErr.EmailErr = "Email is invalid";
    // } else if (toc === "") {
    //   validationErr.TocErr = "Toc cannot be left blank.";
    // } else 
    if (!_.isEmpty(attachmentFile)) {
      let fileSize = attachmentFile?.[0]?.size;
      let sizeInMB = (fileSize / (1024 * 1024)).toFixed(2);
      if (sizeInMB > 2) {
        validationErr.FileErr = "File size cannot be greater than 2MB.";
      }
    } 
    if (msg === "") {
      validationErr.MessageErr = "Message cannot be left blank.";
    }
    setValidationErr(validationErr);
    if (_.isEmpty(validationErr)) {
      let file =
        attachmentFile && attachmentFile.length ? attachmentFile[0] : "";
      const formData = new FormData();
      formData.append("accessType", "HT");
      formData.append("userName", name);
      formData.append("userEmail", email);
      formData.append("feedback", msg);
      formData.append("toc", toc);
      formData.append("application", "Train Fault Reporting");
      formData.append("version", usersReducers?.version);
      formData.append("deviceAPILevel", "API 1.0");
      formData.append("deviceName", "Web");
      formData.append("attach", file);

      dispatch(setLoader(true));
      dispatch(saveFeedback(formData));
      onCancelHandler();
      openCloseModal(false);
    }
  };

  const onCancelHandler = () => {
    setMsg("");
    setAttachmentFile([]);
    setValidationErr({});
  };

  return (
    <>
      <div
        className="modal d-block modal-background"
        id="feedbackModal"
        tabIndex="-1"
        aria-labelledby="feedbackModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="feedbackModalLabel">
                Feedback
              </h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => openCloseModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row card-body p-0">
                <div className="col-md-12">
                  <div className="form-group read-only-cont">
                    <div className="fg-line">
                      <label className="fg-label">
                        {" "}
                        Name <span className="mandatory">* </span>
                      </label>
                      <input
                        readOnly
                        className="feedback-input form-control"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                    {validationErr && validationErr.NameErr && (
                      <div className="msgError help-block">
                        <small className="error">{validationErr.NameErr}</small>
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group">
                    <div className="fg-line">
                      <label className="fg-label">
                        {" "}
                        Email <span className="mandatory">*</span>
                      </label>
                      <input
                        readOnly
                        className="feedback-input form-control"
                        type="text"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    {validationErr && validationErr.EmailErr && (
                      <div className="msgError help-block">
                        <small className="error">
                          {validationErr.EmailErr}
                        </small>
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group read-only-cont">
                    <div className="fg-line">
                      <label className="fg-label">
                        TOC<span className="mandatory">*</span>
                      </label>
                      <input
                        readOnly
                        className="feedback-input form-control"
                        type="text"
                        value={toc}
                        onChange={(e) => setToc(e.target.value)}
                      />
                    </div>
                    {validationErr && validationErr.TocErr && (
                      <div className="msgError help-block">
                        <small className="error">{validationErr.TocErr}</small>
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="file form-group" id="fileErrorDiv">
                    <div className="fg-line">
                      <label className="fg-label">Attachment </label>
                      <input
                        onChange={(e) => setAttachmentFile(e.target.files)}
                        type="file"
                        name="file"
                        id="file"
                        className="attachment-file form-control"
                      />
                    </div>
                    {validationErr && validationErr.FileErr && (
                      <div className="msgError help-block">
                        <small className="error">{validationErr.FileErr}</small>
                      </div>
                    )}
                  </div>
                </div>

                <input
                  type="hidden"
                  name="versionNum"
                  id="versionNum"
                  value={usersReducers?.version}
                />

                <div className="col-md-12">
                  <div className="msg form-group">
                    <div className="fg-line">
                      <label className="fg-label">
                        Message <span className="mandatory">*</span>
                      </label>
                      <textarea
                        id="feedbackmessage"
                        name="message"
                        className="form-control"
                        rows="3"
                        value={msg}
                        // placeholder="Message Here......"
                        onChange={(e) => setMsg(e.target.value)}
                      ></textarea>
                    </div>

                    {validationErr && validationErr.MessageErr && (
                      <div className="msgError help-block">
                        <small className="error feedback-error">
                          {validationErr.MessageErr}
                        </small>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                onClick={() => onSaveHandler()}
                type="button"
                className="btn btn-primary modal-blue-btn"
              >
                Save
              </button>
              <button
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-secondary modal-white-btn"
                aria-label="Close"
                onClick={() => openCloseModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FeedbackForm;
